import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconClearFormatting = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
      data-fill-none
    >
      <path
        d="M7.24219 8.26074V7.9218C7.24207 7.78784 7.26835 7.65517 7.31953 7.53137C7.37072 7.40757 7.4458 7.29507 7.54048 7.2003C7.63517 7.10553 7.7476 7.03035 7.87135 6.97906C7.99511 6.92777 8.12776 6.90137 8.26172 6.90137H15.7383C15.8722 6.90137 16.0049 6.92777 16.1286 6.97906C16.2524 7.03035 16.3648 7.10553 16.4595 7.2003C16.5542 7.29507 16.6293 7.40757 16.6805 7.53137C16.7316 7.65517 16.7579 7.78784 16.7578 7.9218V8.26165"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.0967V13.6982V7.49976"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.96094 17.0967H14.0391"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75138 6.74879L16.8751 17.2498"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);

IconClearFormatting.displayName = 'IconClearFormatting';
